import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../security/authentication.service';
import { AlertService } from '../shared/alert/alert.service';
import { SpinnerService } from '../shared/spinner/spinner.service';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent {

  isPasswordValid: boolean;
  emailErrorMsg: string;
  passwordErrorMsg: string;
  email: string;
  password: string;
  confirm_password: string;
  token: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private spinnerService: SpinnerService
  ) {
    this.route.queryParams
      .subscribe(params => {
        this.token = params['token'];
      })
    ;
  }

  resetPwd(event): void {
    event.preventDefault();
    if (this.checkPassword(true)) {
      this.spinnerService.start('Réinitialisation');
      this.authenticationService.resetPwd(this.token, this.password)
        .then(response => {
          if (response.success) {
            this.alertService.success(response.message);
            this.authenticationService.login(response.mail, this.password)
              .then(function(responseLogin) {
                if (responseLogin.success) {
                  this.router.navigate(['']);
                } else {
                  this.alertService.error(responseLogin.message);
                }
                this.spinnerService.stop();
              }.bind(this));
          } else {
            this.alertService.error(response.message);
          }
          this.spinnerService.stop();
        });
    }
  }

  private checkPasswordComplexity() {
    return this.password.length > 5;
  }

  public checkPassword(showError) {
    let valid = true;
    this.passwordErrorMsg = '';
    if (this.checkPasswordComplexity()) {
      if (this.password !== this.confirm_password) {
        valid = false;
        if (showError && this.confirm_password && this.confirm_password.length > 0) {
          this.passwordErrorMsg = 'Les mots de passes ne sont pas identiques';
        }
      }
    } else {
      valid = false;
      if (this.password.length > 0 && showError) {
        this.passwordErrorMsg = 'Le mot de passe n\'est pas assez sécurisé';
      }
    }
    this.isPasswordValid = valid;
    return valid;
  }

}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts